import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {useNavigate} from "react-router-dom";
import {CiCalendarDate, CiLocationOn} from "react-icons/ci";

const currencyFormat = Intl.NumberFormat('en-US');

function Requests() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [requests, setRequests] = React.useState([]);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            window.location.replace('/login')
        }
        const params = {
            count: 15,
            page: 1,
            list: 1,
            orderBy: 'created_at',
            orderType: 'desc',
            processFor : 'Servitors'
        }

        API.getRequests(params)
            .then((response) => {
                setRequests(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });


    }, []);

    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title='تاریخچه درخواست ها' hasBack={false} />

            <section className="container-fluid  mt-3 py-5 rtl px-0   ">
                <div className="row mx-2 mb-3">
                    {
                        requests.map (request => {
                            return (
                                <div className="col-12 rtl mb-2 request-row pb-2 "
                                     onClick={() => navigate(`/requests/${request.id}`)}
                                >
                                    <div className="row py-2 ">
                                        <div className="col-2 fw-bold text-small-1 text-muted border-bottom pb-3 ">
                                            <img src={request.company.image} alt={request.company.title}

                                            />
                                        </div>
                                        <div className="col-7 fw-bold text-small-1 text-muted border-bottom pb-3">
                                            {request.user.last_name}
                                            &nbsp;
                                            {request.user.username}
                                            <div className='fw-normal text-small-2 mt-2'>
                                                <CiLocationOn className='ms-1' />
                                                {request.address.address.substring(0, 30)}
                                            </div>

                                        </div>
                                        <div className="col-3 text-start border-bottom pb-3">
                                            <div className='text-small-2 bg-success bg-opacity-10 text-center rounded '>
                                                {request.tracking_code}
                                            </div>
                                          {/*  <div className=' mt-3 text-center rounded bg-secondary text-small-3  bg-opacity-10' style={{color: request.last_status.color}}>
                                                {request.last_status.title}
                                            </div>*/}

                                        </div>
                                        <div className="col-6">
                                            <div className='fw-normal text-small-2 mt-2 text-muted'>
                                                <CiCalendarDate className='ms-1' />
                                                {request.doing_date}
                                            </div>
                                        </div>
                                        <div className="col-6 text-start text-secondary mt-2 text-small-1 fw-bolder">
                                            {currencyFormat.format(request.pay_amount)}
                                            &nbsp;
                                            ریال
                                        </div>
                                    </div>
                                </div>
                            )} )
                    }
                </div>

            </section>
            <Navbar />
        </React.Fragment>
    );
}

export default Requests;